// extracted by mini-css-extract-plugin
export default {"topComponentsRow":"GraphComponents_topComponentsRow__kgHNH","activitiesRow":"GraphComponents_activitiesRow__kPwYB"};